import React, { useContext, useEffect } from 'react';
import { Routes, Route } from "react-router-dom";
import { Dashboard, Home, League, Login, Match, Predict, Profile, Ranking  } from "./views";
import { Snackbar } from "@mui/material";
//import firebase from "firebase/app";
import { globalStore } from './state/store';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, getDocs } from "firebase/firestore";
//import "firebase/firestore";

/*
const firebaseConfig = {
  apiKey: "AIzaSyDaKWK8cggMOJJ97Atp_aatXcbs8-Jmd48",
  authDomain: "cuppredictor-33cbc.firebaseapp.com",
  projectId: "cuppredictor-33cbc",
  storageBucket: "cuppredictor-33cbc.appspot.com",
  messagingSenderId: "919951709344",
  appId: "1:919951709344:web:11e56d3cc990e9a540e5c5",
  measurementId: "G-99RY442N7W"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app)*/

function Main() {

  const [state, dispatch] = useContext(globalStore);

  /*
  useEffect(() => {

    initializeUser()
    .then((res) => {
      console.log("res",res)
    })

  }, []);

  async function initializeUser() {
    console.log('calling');

    const testRef = collection(db, "testcol");

    const querySnapshot = await getDocs(testRef);
    querySnapshot.forEach((doc) => {
      console.log(`${doc.id} => ${doc.data()}`);
      console.log("doc.data()", doc.data())
    });

  }*/

  return (
    <>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/league/:type/:lid" element={<League />} />
      <Route path="/login" element={<Login />} />
      <Route path="/predict/:rpage" element={<Predict />} />
      <Route path="/ranking" element={<Ranking />} />
      <Route path="/dashboard/:lid" element={<Dashboard />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/match/:matchid" element={<Match />} />
      <Route path="/profile" element={<Profile />} />
    </Routes>

    <Snackbar
      open={Boolean(state.snackbar)}
      autoHideDuration={4000}
      onClose={e => dispatch({ type: "NEW_SNACKBAR", payload: null })}
      message={state.snackbar !== null ? state.snackbar : ""}
    />
    </>
  );
}

export default Main;
